import { ChevronRight } from 'lucide-react';
import { useCollapsibleState } from '../../hooks/useCollapsibleState';

interface CollapsibleSectionProps {
  sectionId: string;
  title: string;
  children: React.ReactNode;
}

export function CollapsibleSection({ sectionId, title, children }: CollapsibleSectionProps) {
  const [collapsed, toggle] = useCollapsibleState(sectionId);

  return (
    <div>
      <button
        type="button"
        className="flex w-full items-center gap-2 rounded-md px-2 -mx-2 py-2 text-left select-none hover:bg-accent/50 transition-colors"
        aria-expanded={!collapsed}
        onClick={toggle}
      >
        <ChevronRight
          className={`h-5 w-5 text-muted-foreground transition-transform duration-200 ${!collapsed ? 'rotate-90' : ''}`}
          data-testid={collapsed ? 'chevron-right' : 'chevron-down'}
        />
        <span className="text-lg font-semibold">{title}</span>
      </button>
      <div
        className="grid transition-[grid-template-rows] duration-300 ease-in-out"
        style={{ gridTemplateRows: collapsed ? '0fr' : '1fr' }}
      >
        <div className="overflow-hidden">{children}</div>
      </div>
    </div>
  );
}
